import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faEnvelope, faComment, faEllipsisV, faEdit, faTrash, faBan } from '@fortawesome/free-solid-svg-icons';
import { Col, Row, Card, Form, Button, InputGroup, Table, Badge, Dropdown, ButtonGroup, Spinner, Modal } from '@themesberg/react-bootstrap';
import { collection, getDocs, query, orderBy, updateDoc, doc, writeBatch, where, deleteDoc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../../config/firebase';
import { useHistory } from 'react-router-dom';

export default () => {
  const history = useHistory();
  const [searchTerm, setSearchTerm] = useState("");
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [updatingId, setUpdatingId] = useState(null);
  const [updatingAll, setUpdatingAll] = useState(false);
  const [deletingId, setDeletingId] = useState(null);
  const [banningId, setBanningId] = useState(null);
  const [showBanModal, setShowBanModal] = useState(false);
  const [banTargetId, setBanTargetId] = useState(null);
  const [banTargetName, setBanTargetName] = useState(null);

  useEffect(() => {
    loadAccounts();
  }, []);

  const loadAccounts = async () => {
    try {
      setLoading(true);
      // orderBy olmadan sorgula (index gereksinimini önlemek için) ama filtre (where) EKLENMELİ
      const q = query(
        collection(db, 'users'),
        where('isTestUser', '==', true)
      );
      const snapshot = await getDocs(q);
      const accountsList = [];
      snapshot.forEach(doc => {
        const data = doc.data();
        accountsList.push({
          id: doc.id,
          name: data.name || '',
          firstName: data.firstName || '',
          lastName: data.lastName || '',
          gender: data.gender || '',
          age: data.age || 0,
          status: data.isApproved || false,
          profileImageUrl: data.profileImageUrl || null,
          isBanned: data.isBanned || false,
          deviceId: data.deviceId || null,
          createdAt: data.createdAt || null
        });
      });

      // Client-side sıralama
      accountsList.sort((a, b) => {
        const timeA = a.createdAt?.toDate ? a.createdAt.toDate() : (a.createdAt ? new Date(a.createdAt) : new Date(0));
        const timeB = b.createdAt?.toDate ? b.createdAt.toDate() : (b.createdAt ? new Date(b.createdAt) : new Date(0));
        return timeB - timeA; // En yeni önce
      });

      setAccounts(accountsList);
      setError(null);
    } catch (err) {
      console.error("Error loading accounts:", err);
      setError("Hesaplar yüklenirken hata oluştu: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  const toggleApprovalStatus = async (accountId, currentStatus) => {
    try {
      setUpdatingId(accountId);
      await updateDoc(doc(db, 'users', accountId), {
        isApproved: !currentStatus,
        updatedAt: new Date()
      });
      // Listeyi yenile
      await loadAccounts();
    } catch (err) {
      console.error("Error updating approval status:", err);
      alert("Durum güncellenirken hata oluştu: " + err.message);
    } finally {
      setUpdatingId(null);
    }
  };

  const updateAllFakeAccountsToBoth = async () => {
    if (!window.confirm('Tüm fake hesapları "Her İkisi" listesine eklemek istediğinize emin misiniz?')) {
      return;
    }

    try {
      setUpdatingAll(true);
      setError(null);

      // Tüm fake hesapları çek
      const q = query(
        collection(db, 'users'),
        where('isTestUser', '==', true)
      );
      const snapshot = await getDocs(q);

      if (snapshot.empty) {
        alert('Güncellenecek fake hesap bulunamadı.');
        setUpdatingAll(false);
        return;
      }

      // Batch ile güncelle (500'lük gruplar halinde)
      let count = 0;
      const batchSize = 500;
      let batch = writeBatch(db);
      let batchCount = 0;

      for (const docSnapshot of snapshot.docs) {
        const data = docSnapshot.data();
        // Eğer zaten her ikisi de true ise güncelleme yapma
        if (data.showInFeatured !== true || data.showInNearby !== true) {
          batch.update(docSnapshot.ref, {
            showInFeatured: true,
            showInNearby: true
          });
          count++;
          batchCount++;

          // Batch limit'e ulaşırsa commit et ve yeni batch başlat
          if (batchCount >= batchSize) {
            await batch.commit();
            batch = writeBatch(db);
            batchCount = 0;
          }
        }
      }

      // Kalan güncellemeleri commit et
      if (batchCount > 0) {
        await batch.commit();
      }

      if (count > 0) {
        alert(`${count} fake hesap başarıyla güncellendi! Tüm fake hesaplar artık "Her İkisi" listesinde görünecek.`);
        await loadAccounts();
      } else {
        alert('Güncellenecek hesap bulunamadı (zaten güncel olabilir).');
      }
    } catch (err) {
      console.error("Error updating all fake accounts:", err);
      setError("Toplu güncelleme sırasında hata oluştu: " + err.message);
      alert("Toplu güncelleme sırasında hata oluştu: " + err.message);
    } finally {
      setUpdatingAll(false);
    }
  };

  const handleDeleteAccount = async (accountId, accountName) => {
    if (!window.confirm(
      `"${accountName}" kullanıcısını silmek istediğinize emin misiniz?\n\n` +
      `Bu işlem şu verileri KALICI olarak silecektir:\n` +
      `• Profil bilgileri\n` +
      `• Tüm sohbet geçmişi\n` +
      `• Mesajlar\n` +
      `• Beğeniler\n` +
      `• Hediyeler\n` +
      `• Görseller\n\n` +
      `Bu işlem GERİ ALINAMAZ!`
    )) {
      return;
    }

    try {
      setDeletingId(accountId);
      setError(null);

      console.log(`🔥 Starting cascade delete for user: ${accountId} (${accountName})`);

      const batchSize = 500;
      let batch = writeBatch(db);
      let batchCount = 0;
      let deletedCount = 0;

      // 1️⃣ Chat rooms'ı bul ve sil
      console.log(`📱 Looking for chatRooms containing user: ${accountId}`);
      const chatRoomsQuery = query(
        collection(db, 'chatRooms'),
        where('participantUids', 'array-contains', accountId)
      );
      const chatRoomsSnapshot = await getDocs(chatRoomsQuery);
      console.log(`📱 Found ${chatRoomsSnapshot.size} chatRooms to delete`);

      for (const chatRoomDoc of chatRoomsSnapshot.docs) {
        const chatRoomId = chatRoomDoc.id;

        // 1.1 Mesajları sil (alt koleksiyon)
        try {
          const messagesRef = collection(chatRoomDoc.ref, 'messages');
          const messagesSnapshot = await getDocs(messagesRef);
          console.log(`💬 Deleting ${messagesSnapshot.size} messages from room ${chatRoomId}`);

          for (const msgDoc of messagesSnapshot.docs) {
            batch.delete(msgDoc.ref);
            batchCount++;
            deletedCount++;

            if (batchCount >= batchSize) {
              await batch.commit();
              batch = writeBatch(db);
              batchCount = 0;
            }
          }
        } catch (e) {
          console.warn(`No messages collection for room ${chatRoomId}: ${e.message}`);
        }

        // 1.2 Chat room'u sil
        batch.delete(chatRoomDoc.ref);
        batchCount++;
        deletedCount++;

        if (batchCount >= batchSize) {
          await batch.commit();
          batch = writeBatch(db);
          batchCount = 0;
        }
      }

      // 2️⃣ Likes'ı sil (gönderilen ve geçilen)
      console.log(`❤️ Deleting likes for user: ${accountId}`);

      // 2.1 Sent likes
      try {
        const sentLikesRef = collection(db, 'likes', accountId, 'sent');
        const sentLikesSnapshot = await getDocs(sentLikesRef);
        console.log(`💚 Deleting ${sentLikesSnapshot.size} sent likes`);

        for (const doc of sentLikesSnapshot.docs) {
          batch.delete(doc.ref);
          batchCount++;
          deletedCount++;

          if (batchCount >= batchSize) {
            await batch.commit();
            batch = writeBatch(db);
            batchCount = 0;
          }
        }
      } catch (e) {
        console.warn(`No sent likes found: ${e.message}`);
      }

      // 2.2 Passed likes
      try {
        const passedLikesRef = collection(db, 'likes', accountId, 'passed');
        const passedLikesSnapshot = await getDocs(passedLikesRef);
        console.log(`💔 Deleting ${passedLikesSnapshot.size} passed likes`);

        for (const doc of passedLikesSnapshot.docs) {
          batch.delete(doc.ref);
          batchCount++;
          deletedCount++;

          if (batchCount >= batchSize) {
            await batch.commit();
            batch = writeBatch(db);
            batchCount = 0;
          }
        }
      } catch (e) {
        console.warn(`No passed likes found: ${e.message}`);
      }

      // 2.3 Likes ana belgesini sil
      try {
        batch.delete(doc(db, 'likes', accountId));
        batchCount++;
        deletedCount++;

        if (batchCount >= batchSize) {
          await batch.commit();
          batch = writeBatch(db);
          batchCount = 0;
        }
      } catch (e) {
        console.warn(`No likes document found: ${e.message}`);
      }

      // 3️⃣ Gelen beğenileri sil (diğer kullanıcıların bu kullanıcıya gönderdikleri)
      console.log(`📨 Deleting incoming likes for user: ${accountId}`);

      try {
        const allLikesQuery = query(collection(db, 'likes'));
        const allLikesSnapshot = await getDocs(allLikesQuery);

        for (const likesDoc of allLikesSnapshot.docs) {
          try {
            const incomingLikeRef = doc(likesDoc.ref, 'sent', accountId);
            batch.delete(incomingLikeRef);
            batchCount++;
            deletedCount++;

            if (batchCount >= batchSize) {
              await batch.commit();
              batch = writeBatch(db);
              batchCount = 0;
            }
          } catch (e) {
            // Belge yoksa devam et
          }
        }
      } catch (e) {
        console.warn(`Error deleting incoming likes: ${e.message}`);
      }

      // 4️⃣ Gönderilen hediyeleri sil
      console.log(`🎁 Deleting gifts sent by user: ${accountId}`);

      try {
        const giftsQuery = query(
          collection(db, 'giftSent'),
          where('senderId', '==', accountId)
        );
        const giftsSnapshot = await getDocs(giftsQuery);
        console.log(`🎁 Found ${giftsSnapshot.size} gifts to delete`);

        for (const giftDoc of giftsSnapshot.docs) {
          batch.delete(giftDoc.ref);
          batchCount++;
          deletedCount++;

          if (batchCount >= batchSize) {
            await batch.commit();
            batch = writeBatch(db);
            batchCount = 0;
          }
        }
      } catch (e) {
        console.warn(`No gifts found: ${e.message}`);
      }

      // 5️⃣ Storage dosyalarını temizle (R2'deki dosyalar - opsiyonel, orphan kalabilir)
      console.log(`📸 Skipping R2 file cleanup for user: ${accountId} (orphaned files will be cleaned later)`);
      // Not: R2'deki dosyalar silinmeden bırakılıyor. 
      // İleride bir temizlik scripti ile orphan dosyalar silinebilir.

      // 6️⃣ Kullanıcıyı sil (en son)
      console.log(`👤 Deleting user document: ${accountId}`);
      await deleteDoc(doc(db, 'users', accountId));
      deletedCount++;

      // Kalan batch işlemlerini commit et
      if (batchCount > 0) {
        await batch.commit();
      }

      console.log(`✅ Cascade delete completed for user ${accountId}. Total deleted: ${deletedCount} records`);

      alert(`"${accountName}" kullanıcısı ve tüm verileri başarıyla silindi!\n\nToplam ${deletedCount} kayıt temizlendi.`);
      await loadAccounts();
    } catch (err) {
      console.error("Error deleting account:", err);
      setError("Hesap silinirken hata oluştu: " + err.message);
      alert("Hesap silinirken hata oluştu: " + err.message);
    } finally {
      setDeletingId(null);
    }
  };

  const handleBanUser = async (accountId, accountName, currentBanned) => {
    if (!window.confirm(
      currentBanned
        ? `"${accountName}" kullanıcısının banını kaldırmak istediğinize emin misiniz?`
        : `"${accountName}" kullanıcısını banlamak istediğinize emin misiniz?\n\n` +
        `Bu işlem:\n` +
        `• Kullanıcıyı banlar\n` +
        `• Cihazı banlar (uygulamaya giriş yapamaz)\n` +
        `• Yeni hesap açsa bile giriş yapamaz\n\n` +
        `Bu işlem GERİ ALINABİLİR.`
    )) {
      return;
    }

    try {
      setBanningId(accountId);
      setError(null);

      const userRef = doc(db, 'users', accountId);
      const userDoc = await getDoc(userRef);
      const userData = userDoc.data();
      const isBanning = !currentBanned;

      // Kullanıcı bilgilerini güncelle
      await updateDoc(userRef, {
        isBanned: isBanning
      });

      // Cihaz banı - deviceId varsa bannedDevices koleksiyonuna ekle/çıkar
      const deviceId = userData?.deviceId;
      const hardwareId = userData?.hardwareId;
      if (deviceId) {
        const bannedDeviceRef = doc(db, 'bannedDevices', deviceId);
        if (isBanning) {
          // Cihazı banla
          await setDoc(bannedDeviceRef, {
            isBanned: true,
            bannedAt: serverTimestamp(),
            deviceId: deviceId,
            hardwareId: hardwareId || null,
            userId: accountId,
            reason: 'Admin panelden banlandı'
          });
          // hardwareId de varsa ayrıca onu da banla
          if (hardwareId) {
            await setDoc(doc(db, 'bannedDevices', hardwareId), {
              isBanned: true,
              bannedAt: serverTimestamp(),
              deviceId: hardwareId,
              hardwareId: hardwareId,
              linkedPrimaryId: deviceId,
              userId: accountId,
              type: 'hardware_ban',
              reason: 'Admin panelden banlandı'
            });
          }
          console.log(`Device banned: ${deviceId}, hardware: ${hardwareId} for user: ${accountId}`);
        } else {
          // Banı kaldır
          await deleteDoc(bannedDeviceRef);
          if (hardwareId) {
            try { await deleteDoc(doc(db, 'bannedDevices', hardwareId)); } catch (e) { }
          }
          console.log(`Device unbanned: ${deviceId} for user: ${accountId}`);
        }
      } else {
        console.warn(`No deviceId found for user ${accountId}. User ban applied but device ban skipped.`);
      }

      alert(isBanning
        ? `"${accountName}" kullanıcısı ve cihazı başarıyla banlandı. Cihaz artık uygulamaya giriş yapamaz.`
        : `"${accountName}" kullanıcısı ve cihazı banı başarıyla kaldırıldı.`);

      await loadAccounts();
    } catch (err) {
      console.error("Error banning user:", err);
      setError("Kullanıcı banlanırken hata oluştu: " + err.message);
      alert("Kullanıcı banlanırken hata oluştu: " + err.message);
    } finally {
      setBanningId(null);
    }
  };

  const filteredAccounts = accounts.filter(account => {
    if (!searchTerm) return true;
    const searchLower = searchTerm.toLowerCase();
    return (
      account.name.toLowerCase().includes(searchLower) ||
      account.firstName?.toLowerCase().includes(searchLower) ||
      account.lastName?.toLowerCase().includes(searchLower)
    );
  });

  return (
    <>
      <div className="py-4">
        <h4>Listele</h4>
        <p className="text-muted mb-0">Hesaplar / Listele</p>
      </div>

      {error && (
        <div className="alert alert-danger" role="alert">
          {error}
        </div>
      )}

      <Card className="border-0 shadow-sm mb-4">
        <Card.Body>
          <div className="alert alert-info mb-4">
            <strong>Uyarı:</strong> Bu özellikler test amaçlıyla kullanılmalıdır.
          </div>

          <Row className="mb-4">
            <Col md={6}>
              <InputGroup>
                <InputGroup.Text>
                  <FontAwesomeIcon icon={faSearch} />
                </InputGroup.Text>
                <Form.Control
                  type="text"
                  placeholder="Profil Ara..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </InputGroup>
            </Col>
            <Col md={6} className="d-flex justify-content-end align-items-center">
              <Button
                variant="success"
                size="sm"
                onClick={updateAllFakeAccountsToBoth}
                disabled={updatingAll}
                className="me-2"
              >
                {updatingAll ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-2" />
                    Güncelleniyor...
                  </>
                ) : (
                  "Tüm Fake Hesapları 'Her İkisi' Yap"
                )}
              </Button>
              <Button variant="primary" size="sm">
                <FontAwesomeIcon icon={faSearch} className="me-2" />
                Ara
              </Button>
              <Dropdown className="ms-2">
                <Dropdown.Toggle variant="outline-secondary" size="sm">
                  Tüm Profiller
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item>Tüm Profiller</Dropdown.Item>
                  <Dropdown.Item>Kadın Profiller</Dropdown.Item>
                  <Dropdown.Item>Erkek Profiller</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Col>
          </Row>

          {loading ? (
            <div className="d-flex justify-content-center p-5">
              <Spinner animation="border" />
            </div>
          ) : (
            <div className="table-responsive">
              <Table className="table-dark table-hover mb-0" style={{ fontSize: '0.85rem' }}>
                <thead>
                  <tr>
                    <th className="border-0">#</th>
                    <th className="border-0">Profil</th>
                    <th className="border-0">Durum</th>
                    <th className="border-0">Ad Soyad</th>
                    <th className="border-0">Yaş</th>
                    <th className="border-0">Cinsiyet</th>
                    <th className="border-0">İşlemler</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredAccounts.length === 0 ? (
                    <tr>
                      <td colSpan="7" className="text-center p-4">
                        {searchTerm ? "Arama sonucu bulunamadı." : "Henüz test kullanıcısı eklenmemiş."}
                      </td>
                    </tr>
                  ) : (
                    filteredAccounts.map((account, index) => (
                      <tr key={account.id}>
                        <td>{index + 1}</td>
                        <td>
                          {account.profileImageUrl ? (
                            <img
                              src={account.profileImageUrl}
                              alt={account.name}
                              className="rounded-circle"
                              style={{ width: 40, height: 40, objectFit: 'cover' }}
                            />
                          ) : (
                            <div
                              className="rounded-circle bg-secondary d-inline-block"
                              style={{ width: 40, height: 40 }}
                            ></div>
                          )}
                        </td>
                        <td>
                          <Button
                            variant={account.status ? "success" : "danger"}
                            size="sm"
                            onClick={() => toggleApprovalStatus(account.id, account.status)}
                            disabled={updatingId === account.id}
                          >
                            {updatingId === account.id ? (
                              <Spinner animation="border" size="sm" />
                            ) : (
                              account.status ? "Doğrulandı" : "Doğrulanmadı"
                            )}
                          </Button>
                        </td>
                        <td>{account.name}</td>
                        <td>{account.age}</td>
                        <td>
                          <Badge bg={account.gender === "Kadın" ? "danger" : "primary"} className="badge-sm">
                            {account.gender}
                          </Badge>
                        </td>
                        <td>
                          <ButtonGroup size="sm">
                            <Button
                              variant="primary"
                              title="Düzenle"
                              onClick={() => history.push(`/accounts/edit/${account.id}`)}
                            >
                              <FontAwesomeIcon icon={faEdit} />
                            </Button>
                            <Button
                              variant={account.isBanned ? "warning" : "danger"}
                              title={account.isBanned ? "Banı Kaldır" : "Banla"}
                              onClick={() => handleBanUser(account.id, account.name, account.isBanned)}
                              disabled={banningId === account.id}
                            >
                              {banningId === account.id ? (
                                <Spinner animation="border" size="sm" />
                              ) : (
                                <FontAwesomeIcon icon={faBan} />
                              )}
                            </Button>
                            <Button
                              variant="danger"
                              title="Sil"
                              onClick={() => handleDeleteAccount(account.id, account.name)}
                              disabled={deletingId === account.id}
                            >
                              {deletingId === account.id ? (
                                <Spinner animation="border" size="sm" />
                              ) : (
                                <FontAwesomeIcon icon={faTrash} />
                              )}
                            </Button>
                          </ButtonGroup>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
            </div>
          )}
        </Card.Body>
      </Card>
    </>
  );
};
